// Reglas de las acciones de una membresía en la 360 (movidas desde Vision360Table, 113 T034).
// Las usa la pestaña «Mascotas y planes» para decidir qué botones mostrar en cada membresía.

const DEACTIVATED = 4;

// Convierte una fecha DD/MM/YYYY en un entero comparable AAAAMMDD (0 si inválida)
export function startDateRank(dateStr) {
  if (!dateStr || typeof dateStr !== 'string') return 0;
  const parts = dateStr.split('/');
  if (parts.length !== 3) return 0;
  const [day, month, year] = parts;
  return parseInt(`${year}${month.padStart(2, '0')}${day.padStart(2, '0')}`, 10) || 0;
}

// Una membresía "representativa" por mascota. Una mascota puede tener varias
// membresías (p.ej. 2 desactivadas por renovaciones previas + 1 vigente).
// Regla: se prefiere cualquier membresía NO desactivada; si todas están
// desactivadas, se usa la más reciente (por fecha de inicio). Empate entre
// no desactivadas: también la más reciente.
export function representativeIds(detailsPlan = []) {
  const topByPet = {};
  for (const m of detailsPlan) {
    const rank = parseInt(m.status) === DEACTIVATED ? 0 : 1;
    const petKey = m.petId != null ? `id:${m.petId}` : `name:${m.name}|${m.species}`;
    const time = startDateRank(m.startdate);
    const current = topByPet[petKey];
    if (
      !current ||
      rank > current.rank ||
      (rank === current.rank && time > current.time)
    ) {
      topByPet[petKey] = { id: m.id, rank, time };
    }
  }
  return new Set(Object.values(topByPet).map(entry => entry.id));
}

// Acciones visibles de una membresía (nombres de acción de UserActions).
// `representatives` es el Set que devuelve representativeIds(detailsPlan).
export function membershipActions(item, representatives) {
  const actions = ['seeContract', 'updateContract', 'updateMembership'];
  const isRepresentative = representatives.has(item.id);
  const status = parseInt(item.status);
  // Renovación: en la representativa de cada mascota, salvo desactivada
  // (status 4) — el backend no renueva membresías desactivadas. Como la
  // representativa es la NO desactivada cuando existe, esto solo oculta el
  // botón cuando TODAS las membresías de la mascota están desactivadas.
  if (isRepresentative && status !== DEACTIVATED) {
    actions.push('renewMembership');
  }
  // Link de pago MP: la misma representativa, si su plan es de pago
  // (b2c / b2b2c). Incluye activas (si la tarjeta dejó de pagar se genera
  // un nuevo link) y desactivadas/canceladas (para re-suscribir): el
  // backend decide si mantiene o cancela la suscripción anterior según
  // la elección del admin en el aviso.
  if (isRepresentative && item.isPaidPlan) {
    actions.push('regeneratePaymentLink');
  }
  return actions;
}
